import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { Dashboard } from './pages/Dashboard';
import { PaperExplorer } from './pages/PaperExplorer';
import { ModelPerformance } from './pages/ModelPerformance';
import { GraphOverview } from './pages/GraphOverview';
import { About } from './pages/About';
import { AnimatePresence } from 'framer-motion';
import './App.css';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/explorer" element={<PaperExplorer />} />
        <Route path="/performance" element={<ModelPerformance />} />
        <Route path="/graph" element={<GraphOverview />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Router>
      <div className="app-layout">
        <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
        <main className="main-area">
          <AnimatedRoutes />
        </main>
      </div>
    </Router>
  );
}

export default App;
